import axios, { InternalAxiosRequestConfig } from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL })
// const API = axios.create({ baseURL: 'https://sanme-portfolio-c47c6ed45f5f.herokuapp.com' })

//This is going to be a function that's going to happen on each one of our request
API.interceptors.request.use(
  (req) => {
    const authData = localStorage.getItem('authData');

    if (authData && req.headers) {
      const token = JSON.parse(authData).token;
      req.headers.Authorization = `Bearer ${token}`;
    }

    return req;
  },
  (error) => Promise.reject(error)
);

export interface ApiParams {
    id?: any;
    postData?: any;
    userId?: any;
    currentPage?: number;
    page?: any;
}

const enrollment   = '/enrollment'
const contactUs    = '/contact-us'
const newsLetter   = "/news-letter"

//enrollment
export const fetchEnrollmentUsers   = ({page}: ApiParams) => API.get(`${enrollment}?page=${page}`)
export const createEnrollment       = ({postData}: ApiParams) => API.post(`${enrollment}/create`, postData)
//-------------------------------------------------------------------------------------------------------------------------

//contact us
export const createContactUsMessage = ({postData}: ApiParams) => API.post(`${contactUs}/create`, postData);
//-------------------------------------------------------------------------------------------------------------------------------

//newsletter
export const createNewsLetter      = ({postData}: ApiParams) => API.post(`${newsLetter}/create`, postData)